<template>
    <div class="stats view">
        <ComingSoon />
    </div>
</template>
<script>
import ComingSoon from "../components/ComingSoon.vue";
export default {
    inject:["status"],
    components:{
        ComingSoon
    },
}
</script>